var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-media"},[_c('div',[_c('img',{class:`c-media--${_vm.size}`,attrs:{"src":_vm.src}})]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }